import { Alert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Button/Button';
import Input from 'components/shared/Input/Input';
import STEP_DEFINITIONS from 'components/shared/OnboardingWizard/lib/stepDefinitions';
import SUBSTEP_DEFINITIONS from 'components/shared/OnboardingWizard/lib/substepDefinitions';

const PatientCommunicationSection = ({
  formik,
  copyToClipboard,
  twilioError,
  navigateToSubstep,
  practiceAddress
}) => {
  return (
    <div>
      <p className="text-base font-600 text-neutral-900">Patient communication number</p>
      <p className="mb-4 text-sm text-neutral-600">
        A unique number is generated for your practice to handle all patient communications,
        including reminders, invoices, and secure text messaging.
      </p>
      {!practiceAddress || !!twilioError ? (
        <div className="w-full">
          <Alert
            className="w-full"
            color="warning"
            variant="lighter"
            message={
              !practiceAddress ? (
                <div className="flex w-full items-center">
                  Patient communication number will be generated automatically once your
                  <Button
                    text="practice address"
                    variant="link"
                    color="neutral"
                    shade={900}
                    className="px-1 underline"
                    textClassName="first-letter:lowercase"
                    onClick={() =>
                      navigateToSubstep(
                        SUBSTEP_DEFINITIONS[STEP_DEFINITIONS.BASIC_SETUP_CONFIRMATION.code].ADDRESS
                          .code
                      )
                    }
                  />
                  is completed.
                </div>
              ) : (
                <div>{twilioError}</div>
              )
            }
          />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-1 md:grid-cols-2">
          <div className="flex items-end gap-2">
            <Input
              className="flex-1"
              data-qa="practice-twilio-number"
              label="Patient communication phone number"
              name="twilioPhone"
              value={formik.values.twilioPhone}
              rightIcon={formik.values.twilioPhone ? 'copy-mono' : null}
              rightIconClick={
                formik.values.twilioPhone ? () => copyToClipboard(formik.values.twilioPhone) : null
              }
              headerClassName="[&>div:first-child]:justify-between"
              error={twilioError}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientCommunicationSection;
